// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import HttpService from 'src/lib/HttpService';

const DEFAULT_DEVICES_URL = `api/ustrl/v4.0/claimOrders`;
const BULK_CLAIM_ORDER = `api/ustrl/v4.0/claimOrderBulk`;
const DEVICE_URL_V2 = `api/ustrl/v2.0/claimOrders`;
const DEVICE_URL_V5 = `api/ustrl/v5.0/claimOrders`;
const LABEL_PUT_URL_V1 = 'v1.0/shippinglabels/order';
const RECONCILE_USERS = '/usertier/reconcileusers';

const services = {
    async cancelLineItem ({ claimOrderId, lineItemId }: any) {
        return await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_DEVICES_URL}/${claimOrderId}/${lineItemId}/cancel`,
            type: 'patch',
        });
    },

    async cancelLineItemByServiceNotification ({ claimOrderId, serviceNotificationNumber }: any) {
        return await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_DEVICES_URL}/${claimOrderId}/servicenotification/${serviceNotificationNumber}/cancel`,
            type: 'patch',
        });
    },

    async checkout(body: {}) {
        return await HttpService.proxiedApiCall({
            body,
            requestUrl: `${DEVICE_URL_V5}`,
            type: 'post',
        });
    },

    // incidentNumber - service request id
    // serialNumber - line item serial number
    // eventTrigger - shipping_label
    async emailShippingLabel({ incidentNumber, serialNumber } : { incidentNumber: number, serialNumber: number }) {
        const eventTrigger = 'shipping_label';
        return await HttpService.proxiedApiCall({
            body: [],
            requestUrl: `${DEVICE_URL_V2}/${incidentNumber}/lineItems/${serialNumber}/events/${eventTrigger}/notifications`,
            type: 'post',
        });
    },

    async getServiceRequest(serviceRequestId: string) {
        return await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_DEVICES_URL}/${serviceRequestId}`,
            type: 'get',
        });
    },

    async getBulkServiceRequest(serviceRequestIds: string) {
        return await HttpService.proxiedApiCall({
            requestUrl: `${BULK_CLAIM_ORDER}/${serviceRequestIds}`,
            type: 'get',
        });
    },

    async onSiteOrderPatchUpdate(claimOrderId: string, body = {}){
        return await HttpService.proxiedApiCall({
            body,
            requestUrl: `${DEVICE_URL_V5}/${claimOrderId}`,
            type: 'patch',
        });
    },

    async patchUpdate(claimId: string, action: string) {
        return await HttpService.proxiedApiCall({
            body: {
                Action: action,
            },
            requestUrl: `${DEFAULT_DEVICES_URL}/${claimId}`,
            type: 'patch',
        });
    },

    async purchase(claimId: string) {
        return await services.patchUpdate(claimId, 'Purchase');
    },

    async travelSROutcome(claimId: string, action: string, travelSrOutcome: string){
        return await HttpService.proxiedApiCall({
            body: {
                travelSrOutcome,
                Action: action,
            },
            requestUrl: `${DEFAULT_DEVICES_URL}/${claimId}`,
            type: 'patch',
        });
    },

    async getShippingLabel(
        { claimOrderId, lineItemId } :
        { claimOrderId: string, lineItemId: number }
    ) {
        return await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_DEVICES_URL}/${claimOrderId}/${lineItemId}/shippingLabel`,
            type: 'get',
        });
    },

    async onDemandPurchase(body: {}) {
        return await HttpService.proxiedApiCall({
            body,
            requestUrl: `${DEVICE_URL_V5}`,
            type: 'put',
        });
    },
    async regenerateShippingLabel(
        { claimOrderId, lineItemId } :
        { claimOrderId: string, lineItemId: number }
    ) {
        return await HttpService.proxiedApiCall({
            requestUrl: `${DEVICE_URL_V2}/${claimOrderId}/${lineItemId}/RegenerateShippingLabel`,
            type: 'post',
        });
    },

    async putReconcileShippingLabel(
       serviceRequestNumber : string
    ) {
        return await HttpService.proxiedApiCall({
            requestUrl: `${LABEL_PUT_URL_V1}/${serviceRequestNumber}`,
            type: 'put'
        });
    },

    async getReconcileUsers(){
    return await HttpService.proxiedApiCall({
            requestUrl: `${RECONCILE_USERS}`,
            type: 'get'
        });
    }
};

export default services;
